import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box } from '@material-ui/core';
import Lottie from 'react-lottie';
import animation from '../lotties/loading-cart.json';


const Loader = (props) => {

  const navigate = useNavigate();
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (sessionStorage.getItem('token') === "" || sessionStorage.getItem('token') == null || sessionStorage.getItem('token') === undefined) {

        navigate('/login ');
      } else {
        navigate('/dashboard/app');
      }
    }, 3200);
    return () => clearTimeout(timer);

  },);

  return (
    <div style={{ marginTop: "20rem" }}>

      <Lottie
        options={defaultOptions}
        height={200}
        width={200}
      />
    </div>
  );
}
export default Loader;